export default __webpack_public_path__ + "static/media/phos.e1b2b9b3.jpg";